import { CHANGE_EVENT_PREFERENCES } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { FullUserBoundary } from '@ui/general';
import { SalesforceButton } from './SalesforceButton';
import { SyncOutlined } from '@ant-design/icons';
import { useAction } from '@hooks';
import { Button, Space } from 'antd';
import React, { useCallback } from 'react';
export const MonitoredObjectsButtons = ({ refreshing, salesforceUrl, onRefresh }) => {
    const postDataSecurityStatus = useAction(coreActions.requestPostCoreDataSecurityStatus);
    const handleRefreshClick = useCallback(() => {
        postDataSecurityStatus({
            enable: true
        });
        onRefresh();
    }, [postDataSecurityStatus, onRefresh]);
    const handleManageClick = useCallback(() => {
        postDataSecurityStatus({
            enable: false
        });
    }, [postDataSecurityStatus]);
    return (React.createElement(FullUserBoundary, null,
        React.createElement(Space, { align: 'center', className: 'edit-buttons' },
            React.createElement(Button, { disabled: refreshing, icon: React.createElement(SyncOutlined, null), onClick: handleRefreshClick }, CHANGE_EVENT_PREFERENCES.REFRESH_OBJECTS),
            React.createElement(SalesforceButton, { href: salesforceUrl, name: CHANGE_EVENT_PREFERENCES.MANAGE_OBJECTS, onClick: handleManageClick }))));
};
